import apiFetch from '../apiFetch'

export default function (token, operationTypeId) {
  return apiFetch({ endPoint: `OperationType/${operationTypeId}/ExistsDossiersAssociated`, method: 'GET', body: null, token: token })
}
